import styled from 'styled-components';

import media from '../../../styles/media.style';
import {
  BLACK,
  PLACEHOLDER_GRAY,
  MOBILE_PADDING,
  NAVIGATION_MOBILE_HEIGHT,
} from '../../../styles/variables.style';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 100%;
  width: 1000px;
  margin: 15px auto 20px;
  padding: ${NAVIGATION_MOBILE_HEIGHT}px ${MOBILE_PADDING}px 0;

  ${media.tabletL`
    flex-direction: row;
    padding: 0 20px;
    margin: 80px auto 60px;
  `};
`;

export const Description = styled.div`
  p {
    color: ${BLACK};

    ${media.tabletL`
      font-size: 18px;
    `};
  }
`;

export const Slide = styled.div`
  margin: auto;
  max-width: 1050px;
  width: 100%;
`;

export const HeroImagesWrapper = styled.div`
  margin: 0 auto 10px;
  max-width: ${({ placeholder }) => (placeholder ? '1050px' : 'unset')};
  width: 100%;

  ${media.tabletL`
    width: 500px;
    margin: 0 auto 60px;
  `};
`;

export const TopRow = styled.div`
  margin: 0;

  ${media.tabletL`
    max-width: 500px;
  `};
`;

export const BottomRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px ${MOBILE_PADDING}px 0;
  width: 100%;

  ${media.tabletL`
    justify-content: center;
    padding: ${({ isCa }) => (isCa ? '0 0 0 40px' : '0 0 0 150px')};
  `};
`;

export const LeftSection = styled.div`
  margin-bottom: 20px;

  ${media.tabletL`
    width: 100%;
  `};
`;

export const RightSection = styled.div`
  ${media.tabletL`
    width: 100%;
  `};
`;

export const SectionUnorderedList = styled.ul`
  display: flex;
  height: ${({ isLoading, height }) => (isLoading ? `${height}` : null)};
  list-style: none;
  margin-bottom: 3em;
  background: ${({ isLoading }) => (isLoading ? `${PLACEHOLDER_GRAY}` : null)};
`;

export const SectionListItemWrapper = styled.li`
  display: inline-block;
  flex: 1;
`;

export const SectionListItem = styled.div`
  font-weight: 600;
  padding: 0.6em 10px;
  background: ${({ background }) => background};
`;

export const Title = styled.h5`
  margin-bottom: 0;
  color: ${BLACK};
  font-size: 22px;
  text-transform: uppercase;

  ${media.tabletL`
    margin-bottom: 40px;
    font-size: 30px;
  `};
`;

export const Catchline = styled.p`
  color: ${BLACK};
  font-size: 26px;
  line-height: 1.25;
  margin: 0;

  ${media.tabletL`
    font-size: 20px;
  `};
`;



// WEBPACK FOOTER //
// ./src/pages/StylePage/StylesLooksCarousel/StylesLooksCarousel.style.js